export const defaultLanguage = "en";

export const supportedLanguages = [
  { code: "en", name: "English" },
  { code: "ar", name: "عربي" },
];
